import { format } from "date-fns"
import { computeAttendanceForPeriod } from "./attendanceCompute"
import { User } from "@/entities/user/user"
import { _computeStatsForYoungs, ExportPeriod } from "./computeStatsForYoungs"
import { SchoolYear } from "@/entities/schoolYear/schoolYear"

export const computeStatsForYoungs = (
   youngs: User[],
   period: ExportPeriod,
   currentSchoolYear: SchoolYear,
) => _computeStatsForYoungs(youngs, period, currentSchoolYear, computeAttendanceForPeriod)

export async function exportStatsToCSV(
   youngs: User[],
   period: ExportPeriod,
   currentSchoolYear: SchoolYear,
) {
   const { stats, globalStats } = await computeStatsForYoungs(youngs, period, currentSchoolYear)

   const headers = [
      "Prénom",
      "Nom",
      "Groupe",
      "Début Periode",
      "Fin Periode",
      "Présents %",
      "Présents (sans retard) %",
      "Absences Justifiées %",
      "Absences Non Justifiées %",
      "Jours Total",
      "Jours Présent",
      "Jours Présent (sans retard)",
      "Jours Absence Justifiée",
      "Jours Absence Non Justifiée",
      "Jours Retard",
   ]

   const globalStatsToRow = {
      young: {
         firstName: "TOTAL",
         lastName: "",
         group: "",
      },
      ...globalStats,
   }

   const rows = [globalStatsToRow, ...stats].map((stat) => [
      stat.young.firstName,
      stat.young.lastName,
      stat.young.group,
      format(period.from, "dd/MM/yyyy"),
      format(period.to, "dd/MM/yyyy"),
      stat.presentPercentage.toFixed(0),
      stat.perfectPresentPercentage.toFixed(0),
      stat.absentJustifiedPercentage.toFixed(0),
      stat.absentNotJustifiedPercentage.toFixed(0),
      stat.inSchoolDaysCount.toFixed(0),
      stat.present.toFixed(0),
      stat.perfectPresent.toFixed(0),
      stat.absentJustified.toFixed(0),
      stat.absentNotJustified.toFixed(0),
      stat.late.toFixed(0),
   ])

   const csvContent = [headers, ...rows].map((row) => row.join(";")).join("\n")

   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
   const link = document.createElement("a")
   const url = URL.createObjectURL(blob)
   link.setAttribute("href", url)
   link.setAttribute("download", "statistiques_presence.csv")
   link.style.visibility = "hidden"
   document.body.appendChild(link)
   link.click()
   document.body.removeChild(link)
}
